export default __webpack_public_path__ + "static/media/leg-icon-quick.16ae1a68.png";